// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useEffect, useRef } from 'react';
import PlainList from '../../autosuggest/plain-list';
import VirtualList from '../../autosuggest/virtual-list';
import InternalLiveRegion from '../../live-region/internal';
import { useAnnouncement } from '../../select/utils/use-announcement';
const createMouseEventHandler = (handler) => (itemIndex) => {
    if (itemIndex > -1) {
        handler(itemIndex);
    }
};
export default function MenuDropdown({ menu, statusType, menuItemsState, menuItemsHandlers, highlightedOptionId, highlightText, listId, controlId, handleLoadMore, hasDropdownStatus, listBottom, ariaDescribedby, optionsListCustomProperties, }) {
    const handleMouseUp = createMouseEventHandler(menuItemsHandlers.selectVisibleOptionWithMouse);
    const handleMouseMove = createMouseEventHandler(menuItemsHandlers.highlightVisibleOptionWithMouse);
    const ListComponent = menu.virtualScroll ? VirtualList : PlainList;
    const announcement = useAnnouncement({
        highlightText,
        announceSelected: false,
        highlightedOption: menuItemsState.highlightedOption,
        getParent: option => menuItemsState.getItemGroup(option),
    });
    // Force re-announcement when the filtered items list changes.
    // The screenReaderContent on SelectableItem only works for keyboard
    // navigation (highlight moving between existing items). When filtering
    // replaces the entire list, new items mount already highlighted and
    // the SR doesn't pick up the initial textContent set.
    const liveRegionRef = useRef(null);
    const prevItemsLengthRef = useRef(menuItemsState.items.length);
    useEffect(() => {
        var _a;
        if (menuItemsState.items.length !== prevItemsLengthRef.current && announcement) {
            (_a = liveRegionRef.current) === null || _a === void 0 ? void 0 : _a.reannounce();
        }
        prevItemsLengthRef.current = menuItemsState.items.length;
    }, [menuItemsState.items.length, announcement]);
    return (React.createElement(React.Fragment, null,
        React.createElement(InternalLiveRegion, { ref: liveRegionRef, tagName: "span", hidden: true }, announcement),
        React.createElement(ListComponent, { listBottom: listBottom, handleLoadMore: handleLoadMore, autosuggestItemsState: menuItemsState, highlightText: highlightText, highlightedA11yProps: highlightedOptionId ? { id: highlightedOptionId } : {}, hasDropdownStatus: hasDropdownStatus, menuProps: {
                id: listId,
                ariaLabelledby: controlId,
                onMouseUp: handleMouseUp,
                onMouseMove: handleMouseMove,
                ariaDescribedby,
                statusType: statusType !== null && statusType !== void 0 ? statusType : 'finished',
                customProperties: optionsListCustomProperties,
            }, screenReaderContent: announcement })));
}
//# sourceMappingURL=menu-dropdown.js.map